import React from 'react';
import {
  Icon,
  LinearGradient,
  Link,
  Pressable,
  SimpleStyleScrollView,
  Switch,
  withTheme,
} from '@draftbit/ui';
import { useNavigation } from '@react-navigation/native';
import * as Linking from 'expo-linking';
import { Image, Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import * as test from '../custom-files/test';
import resetGlobals from '../global-functions/resetGlobals';
import palettes from '../themes/palettes';
import * as Utils from '../utils';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import useWindowDimensions from '../utils/useWindowDimensions';

const defaultProps = { screen: 'overview' };

const SideMenuBlock = props => {
  const { theme } = props;
  const dimensions = useWindowDimensions();
  const navigation = useNavigation();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [toggleSettings, setToggleSettings] = React.useState(false);
  const [toggleWhatIf, setToggleWhatIf] = props.setToggleWhatIf
    ? [
        props.toggleWhatIf !== undefined ? props.toggleWhatIf : false,
        props.setToggleWhatIf,
      ]
    : React.useState(false);
  const [trigger, setTrigger] = props.setTrigger
    ? [props.trigger !== undefined ? props.trigger : false, props.setTrigger]
    : React.useState(false);

  return (
    <SimpleStyleScrollView
      bounces={true}
      horizontal={false}
      keyboardShouldPersistTaps={'never'}
      nestedScrollEnabled={false}
      showsHorizontalScrollIndicator={true}
      showsVerticalScrollIndicator={true}
      style={StyleSheet.applyWidth(
        {
          backgroundColor: {
            minWidth: Breakpoints.Laptop,
            value: palettes.Brand.Background,
          },
          borderColor: {
            minWidth: Breakpoints.Laptop,
            value: palettes.App['App Blue Light'],
          },
          borderRightWidth: { minWidth: Breakpoints.Laptop, value: 3 },
          flex: { minWidth: Breakpoints.Laptop, value: 1 },
          maxWidth: [
            {
              minWidth: Breakpoints.Laptop,
              value: dimensions.width * (20 / 100),
            },
            {
              minWidth: Breakpoints.Desktop,
              value: dimensions.width * (15 / 100),
            },
          ],
          width: [
            { minWidth: Breakpoints.Laptop, value: '20%' },
            { minWidth: Breakpoints.Desktop, value: '15%' },
          ],
        },
        dimensions.width
      )}
    >
      {/* Logo */}
      <View
        style={StyleSheet.applyWidth(
          {
            alignItems: { minWidth: Breakpoints.Desktop, value: 'center' },
            alignSelf: { minWidth: Breakpoints.Laptop, value: 'center' },
            marginTop: { minWidth: Breakpoints.Laptop, value: '5%' },
          },
          dimensions.width
        )}
      >
        <Image
          {...GlobalStyles.ImageStyles(theme)['Image'].props}
          resizeMode={'contain'}
          source={imageSource(Images['logocropped'])}
          style={StyleSheet.applyWidth(
            StyleSheet.compose(GlobalStyles.ImageStyles(theme)['Image'].style, {
              height: [
                { minWidth: Breakpoints.Laptop, value: 150 },
                { minWidth: Breakpoints.Desktop, value: 150 },
              ],
              width: [
                { minWidth: Breakpoints.Laptop, value: 150 },
                { minWidth: Breakpoints.Desktop, value: 150 },
              ],
            }),
            dimensions.width
          )}
        />
      </View>
      {/* Menu Main View */}
      <View
        style={StyleSheet.applyWidth(
          {
            alignItems: { minWidth: Breakpoints.Laptop, value: 'flex-end' },
            flex: { minWidth: Breakpoints.Laptop, value: 1 },
            justifyContent: {
              minWidth: Breakpoints.Laptop,
              value: 'space-between',
            },
            paddingBottom: { minWidth: Breakpoints.Laptop, value: 24 },
          },
          dimensions.width
        )}
      >
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: { minWidth: Breakpoints.Laptop, value: 'flex-end' },
              gap: { minWidth: Breakpoints.Laptop, value: 50 },
              marginTop: {
                minWidth: Breakpoints.Laptop,
                value: dimensions.height * (10 / 100),
              },
              width: { minWidth: Breakpoints.Laptop, value: '100%' },
            },
            dimensions.width
          )}
        >
          {/* Dashboard */}
          <>
            {(props.screen ?? defaultProps.screen) === 'dashboard' ? null : (
              <Pressable
                onPress={() => {
                  try {
                    navigation.navigate('DashboardScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={StyleSheet.applyWidth(
                  { width: { minWidth: Breakpoints.Laptop, value: '75%' } },
                  dimensions.width
                )}
              >
                <LinearGradient
                  color1={theme.colors.branding.primary}
                  color2={theme.colors.branding.secondary}
                  endY={100}
                  startX={0}
                  startY={0}
                  {...GlobalStyles.LinearGradientStyles(theme)['Blue Linear']
                    .props}
                  endX={0}
                  style={StyleSheet.applyWidth(
                    GlobalStyles.LinearGradientStyles(theme)['Blue Linear']
                      .style,
                    dimensions.width
                  )}
                >
                  <Icon
                    size={24}
                    {...GlobalStyles.IconStyles(theme)['Menu Icon'].props}
                    name={'FontAwesome/line-chart'}
                    style={StyleSheet.applyWidth(
                      GlobalStyles.IconStyles(theme)['Menu Icon'].style,
                      dimensions.width
                    )}
                  />
                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Menu Text'].props}
                    style={StyleSheet.applyWidth(
                      GlobalStyles.TextStyles(theme)['Menu Text'].style,
                      dimensions.width
                    )}
                  >
                    {'Dashboard'}
                  </Text>
                </LinearGradient>
              </Pressable>
            )}
          </>
          {/* Income */}
          <>
            {(props.screen ?? defaultProps.screen) === 'income' ? null : (
              <Pressable
                onPress={() => {
                  try {
                    navigation.navigate('IncomeFormScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={StyleSheet.applyWidth(
                  { width: { minWidth: Breakpoints.Laptop, value: '75%' } },
                  dimensions.width
                )}
              >
                <LinearGradient
                  color1={theme.colors.branding.primary}
                  color2={theme.colors.branding.secondary}
                  endY={100}
                  startX={0}
                  startY={0}
                  {...GlobalStyles.LinearGradientStyles(theme)['Blue Linear']
                    .props}
                  endX={0}
                  style={StyleSheet.applyWidth(
                    GlobalStyles.LinearGradientStyles(theme)['Blue Linear']
                      .style,
                    dimensions.width
                  )}
                >
                  <Icon
                    size={24}
                    {...GlobalStyles.IconStyles(theme)['Menu Icon'].props}
                    name={'Feather/dollar-sign'}
                    style={StyleSheet.applyWidth(
                      GlobalStyles.IconStyles(theme)['Menu Icon'].style,
                      dimensions.width
                    )}
                  />
                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Menu Text'].props}
                    style={StyleSheet.applyWidth(
                      GlobalStyles.TextStyles(theme)['Menu Text'].style,
                      dimensions.width
                    )}
                  >
                    {'Income'}
                  </Text>
                </LinearGradient>
              </Pressable>
            )}
          </>
          {/* Expenses */}
          <>
            {(props.screen ?? defaultProps.screen) === 'expenses' ? null : (
              <Pressable
                onPress={() => {
                  try {
                    navigation.navigate('ExpensesFormScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={StyleSheet.applyWidth(
                  { width: { minWidth: Breakpoints.Laptop, value: '75%' } },
                  dimensions.width
                )}
              >
                <Utils.CustomCodeErrorBoundary>
                  <test.BounceAnimation trigger={trigger} />
                </Utils.CustomCodeErrorBoundary>
              </Pressable>
            )}
          </>
          {/* Overview */}
          <>
            {(props.screen ?? defaultProps.screen) === 'overview' ? null : (
              <Pressable
                onPress={() => {
                  try {
                    navigation.navigate('OverviewScreen');
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={StyleSheet.applyWidth(
                  { width: { minWidth: Breakpoints.Laptop, value: '75%' } },
                  dimensions.width
                )}
              >
                <LinearGradient
                  endY={100}
                  startX={0}
                  startY={0}
                  {...GlobalStyles.LinearGradientStyles(theme)['Blue Linear']
                    .props}
                  color1={palettes.Brand['App Blue Dark']}
                  color2={palettes.App['App Blue Light']}
                  color3={palettes.Brand['App Blue Dark']}
                  endX={0}
                  style={StyleSheet.applyWidth(
                    GlobalStyles.LinearGradientStyles(theme)['Blue Linear']
                      .style,
                    dimensions.width
                  )}
                >
                  <Icon
                    size={24}
                    {...GlobalStyles.IconStyles(theme)['Menu Icon'].props}
                    name={'MaterialCommunityIcons/bank'}
                    style={StyleSheet.applyWidth(
                      GlobalStyles.IconStyles(theme)['Menu Icon'].style,
                      dimensions.width
                    )}
                  />
                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Menu Text'].props}
                    style={StyleSheet.applyWidth(
                      GlobalStyles.TextStyles(theme)['Menu Text'].style,
                      dimensions.width
                    )}
                  >
                    {'Overview'}
                  </Text>
                </LinearGradient>
              </Pressable>
            )}
          </>
          {/* WhatIf */}
          <>
            {!(
              (props.screen ?? defaultProps.screen) === 'overview' ||
              (props.screen ?? defaultProps.screen) === 'whatif' ||
              (props.screen ?? defaultProps.screen) === 'dashboard'
            ) ? null : (
              <Pressable
                onPress={() => {
                  try {
                    setToggleWhatIf(true);
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={StyleSheet.applyWidth(
                  { width: { minWidth: Breakpoints.Laptop, value: '75%' } },
                  dimensions.width
                )}
              >
                <LinearGradient
                  endY={100}
                  startX={0}
                  startY={0}
                  {...GlobalStyles.LinearGradientStyles(theme)['Blue Linear']
                    .props}
                  color1={palettes.Brand['App Blue Dark']}
                  color2={palettes.App['App Blue Light']}
                  color3={palettes.Brand['App Blue Dark']}
                  endX={0}
                  style={StyleSheet.applyWidth(
                    GlobalStyles.LinearGradientStyles(theme)['Blue Linear']
                      .style,
                    dimensions.width
                  )}
                >
                  <Icon
                    size={24}
                    {...GlobalStyles.IconStyles(theme)['Menu Icon'].props}
                    name={'AntDesign/questioncircleo'}
                    style={StyleSheet.applyWidth(
                      GlobalStyles.IconStyles(theme)['Menu Icon'].style,
                      dimensions.width
                    )}
                  />
                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Menu Text'].props}
                    style={StyleSheet.applyWidth(
                      GlobalStyles.TextStyles(theme)['Menu Text'].style,
                      dimensions.width
                    )}
                  >
                    {'What If'}
                  </Text>
                </LinearGradient>
              </Pressable>
            )}
          </>
        </View>
        {/* View 2 */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: { minWidth: Breakpoints.Laptop, value: 'flex-end' },
              marginTop: { minWidth: Breakpoints.Laptop, value: 50 },
              width: { minWidth: Breakpoints.Laptop, value: '100%' },
            },
            dimensions.width
          )}
        >
          {/* Settings */}
          <>
            {!toggleSettings ? null : (
              <View
                style={StyleSheet.applyWidth(
                  { width: { minWidth: Breakpoints.Laptop, value: '75%' } },
                  dimensions.width
                )}
              >
                <Pressable
                  onPress={() => {
                    try {
                      navigation.navigate('AccountScreen');
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  style={StyleSheet.applyWidth(
                    { width: { minWidth: Breakpoints.Laptop, value: '75%' } },
                    dimensions.width
                  )}
                >
                  {/* Account View */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: [
                          { minWidth: Breakpoints.Desktop, value: 'center' },
                          { minWidth: Breakpoints.Laptop, value: 'center' },
                        ],
                        flexDirection: [
                          { minWidth: Breakpoints.Laptop, value: 'row' },
                          { minWidth: Breakpoints.Desktop, value: 'row' },
                        ],
                        gap: [
                          { minWidth: Breakpoints.Laptop, value: 12 },
                          { minWidth: Breakpoints.Desktop, value: 12 },
                        ],
                        marginBottom: {
                          minWidth: Breakpoints.Laptop,
                          value: 25,
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <Icon
                      size={24}
                      color={palettes.Brand.White}
                      name={'MaterialIcons/account-circle'}
                      style={StyleSheet.applyWidth(
                        {
                          opacity: {
                            minWidth: Breakpoints.Desktop,
                            value:
                              Constants['SWITCH_SCREEN_MODE'] === false
                                ? '100%'
                                : '50%',
                          },
                        },
                        dimensions.width
                      )}
                    />
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          {
                            color: {
                              minWidth: Breakpoints.Laptop,
                              value: palettes.Brand.White,
                            },
                            fontFamily: {
                              minWidth: Breakpoints.Laptop,
                              value: 'OpenSans_700Bold',
                            },
                            fontSize: {
                              minWidth: Breakpoints.Laptop,
                              value: 12,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Account'}
                    </Text>
                  </View>
                </Pressable>
                {/* Switch View */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: [
                        { minWidth: Breakpoints.Desktop, value: 'center' },
                        { minWidth: Breakpoints.Laptop, value: 'center' },
                      ],
                      flexDirection: [
                        { minWidth: Breakpoints.Laptop, value: 'row' },
                        { minWidth: Breakpoints.Desktop, value: 'row' },
                      ],
                      gap: [
                        { minWidth: Breakpoints.Laptop, value: 12 },
                        { minWidth: Breakpoints.Desktop, value: 12 },
                      ],
                      marginBottom: { minWidth: Breakpoints.Laptop, value: 25 },
                      width: { minWidth: Breakpoints.Laptop, value: '75%' },
                    },
                    dimensions.width
                  )}
                >
                  <Icon
                    size={24}
                    color={palettes.Brand.White}
                    name={'Ionicons/moon'}
                    style={StyleSheet.applyWidth(
                      {
                        opacity: [
                          {
                            minWidth: Breakpoints.Desktop,
                            value:
                              Constants['SWITCH_SCREEN_MODE'] === false
                                ? '100%'
                                : '50%',
                          },
                          {
                            minWidth: Breakpoints.Laptop,
                            value:
                              Constants['SWITCH_SCREEN_MODE'] === false
                                ? '100%'
                                : '20%',
                          },
                        ],
                      },
                      dimensions.width
                    )}
                  />
                  <Switch
                    onValueChange={newSwitchValue => {
                      try {
                        setGlobalVariableValue({
                          key: 'SWITCH_SCREEN_MODE',
                          value: !Constants['SWITCH_SCREEN_MODE'],
                        });
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                    activeTrackColor={palettes.Brand['App Green']}
                    value={Constants['SWITCH_SCREEN_MODE']}
                  />
                  {/* Icon 2 */}
                  <Icon
                    size={24}
                    color={palettes.Brand.White}
                    name={'Ionicons/sunny-sharp'}
                    style={StyleSheet.applyWidth(
                      {
                        opacity: [
                          {
                            minWidth: Breakpoints.Desktop,
                            value:
                              Constants['SWITCH_SCREEN_MODE'] === true
                                ? '100%'
                                : '50%',
                          },
                          {
                            minWidth: Breakpoints.Laptop,
                            value:
                              Constants['SWITCH_SCREEN_MODE'] === true
                                ? '100%'
                                : '20%',
                          },
                        ],
                      },
                      dimensions.width
                    )}
                  />
                </View>
                {/* View 2 */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      justifyContent: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                      marginBottom: { minWidth: Breakpoints.Laptop, value: 25 },
                      width: { minWidth: Breakpoints.Laptop, value: '75%' },
                    },
                    dimensions.width
                  )}
                >
                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Text'].props}
                    style={StyleSheet.applyWidth(
                      StyleSheet.compose(
                        GlobalStyles.TextStyles(theme)['Text'].style,
                        {
                          color: {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.Brand.White,
                          },
                        }
                      ),
                      dimensions.width
                    )}
                  >
                    {'Assistance? '}
                    <Link
                      accessible={true}
                      onPress={() => {
                        try {
                          Linking.openURL('mailto:support@cashplanit.com');
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      selectable={false}
                      {...GlobalStyles.LinkStyles(theme)['Link'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.LinkStyles(theme)['Link'].style,
                          {
                            color: {
                              minWidth: Breakpoints.Laptop,
                              value: palettes.App['App Blue Light'],
                            },
                            textDecorationLine: {
                              minWidth: Breakpoints.Laptop,
                              value: 'underline',
                            },
                          }
                        ),
                        dimensions.width
                      )}
                      title={'support@cashplanit.com'}
                    />
                  </Text>
                </View>

                <Pressable
                  onPress={() => {
                    try {
                      setGlobalVariableValue({
                        key: 'AUTH_TOKEN',
                        value: '',
                      });
                      setGlobalVariableValue({
                        key: 'USER_DETAILS',
                        value: '',
                      });
                      resetGlobals(Variables, setGlobalVariableValue);
                      navigation.navigate('LoginScreen');
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                >
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        flexDirection: {
                          minWidth: Breakpoints.Laptop,
                          value: 'row',
                        },
                        gap: { minWidth: Breakpoints.Laptop, value: 12 },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'flex-start',
                        },
                        marginBottom: {
                          minWidth: Breakpoints.Laptop,
                          value: 25,
                        },
                        width: { minWidth: Breakpoints.Laptop, value: '75%' },
                      },
                      dimensions.width
                    )}
                  >
                    <Icon
                      size={24}
                      color={StyleSheet.getWidthValue(
                        [
                          {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.Brand.White,
                          },
                        ],
                        dimensions.width
                      )}
                      name={'FontAwesome/sign-out'}
                    />
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          {
                            color: {
                              minWidth: Breakpoints.Laptop,
                              value: palettes.Brand.White,
                            },
                            fontFamily: {
                              minWidth: Breakpoints.Laptop,
                              value: 'OpenSans_700Bold',
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Logout'}
                    </Text>
                  </View>
                </Pressable>
              </View>
            )}
          </>
          {/* Settings */}
          <>
            {(props.screen ?? defaultProps.screen) === 'settings' ? null : (
              <Pressable
                onPress={() => {
                  try {
                    setToggleSettings(!toggleSettings);
                  } catch (err) {
                    console.error(err);
                  }
                }}
                style={StyleSheet.applyWidth(
                  { width: { minWidth: Breakpoints.Laptop, value: '75%' } },
                  dimensions.width
                )}
              >
                <LinearGradient
                  endY={100}
                  startX={0}
                  startY={0}
                  {...GlobalStyles.LinearGradientStyles(theme)['Blue Linear']
                    .props}
                  color1={palettes.Brand['App Blue Dark']}
                  color2={palettes.App['App Blue Light']}
                  color3={palettes.Brand['App Blue Dark']}
                  endX={0}
                  style={StyleSheet.applyWidth(
                    GlobalStyles.LinearGradientStyles(theme)['Blue Linear']
                      .style,
                    dimensions.width
                  )}
                >
                  <Icon
                    size={24}
                    {...GlobalStyles.IconStyles(theme)['Menu Icon'].props}
                    name={'MaterialIcons/settings'}
                    style={StyleSheet.applyWidth(
                      GlobalStyles.IconStyles(theme)['Menu Icon'].style,
                      dimensions.width
                    )}
                  />
                  <Text
                    accessible={true}
                    selectable={false}
                    {...GlobalStyles.TextStyles(theme)['Menu Text'].props}
                    style={StyleSheet.applyWidth(
                      GlobalStyles.TextStyles(theme)['Menu Text'].style,
                      dimensions.width
                    )}
                  >
                    {'Settings'}
                  </Text>
                </LinearGradient>
              </Pressable>
            )}
          </>
        </View>
      </View>
    </SimpleStyleScrollView>
  );
};

export default withTheme(SideMenuBlock);
